/* KEOPSY AI Design Studio — storefront canvas editor (F1 MVP).
   Generates AI artwork sized to the product's print dimensions + bleed, lets the
   customer edit, then exports a print-ready 300 DPI PNG, uploads it to the KEOPSY
   Worker (R2) and hands the URL back to the product page for the configurator. */
(function () {
  "use strict";

  function boot() {
    var root = document.querySelector("[data-kp-studio]");
    if (!root) return;
    if (!window.fabric) { return setTimeout(boot, 120); } // wait for Fabric

    var API = (root.getAttribute("data-api") || "").replace(/\/+$/, "");
    var FREE = parseInt(root.getAttribute("data-free"), 10) || 6;
    var $ = function (sel) { return root.querySelector(sel); };
    function studioOptionLabel(value) {
      var text = String(value == null ? "" : value);
      var translations = { Rectangle: "Rectángulo", Square: "Cuadrado", Circle: "Círculo", Oval: "Óvalo", "Gloss Cover": "Cubierta brillante", "Matte Cover": "Cubierta mate", "No Coating": "Sin recubrimiento", "Both sides": "Ambos lados", Front: "Frente", Back: "Reverso", Landscape: "Horizontal", Portrait: "Vertical" };
      if (translations[text]) return translations[text];
      return text.replace(/\bGloss Cover\b/gi, "Cubierta brillante").replace(/\bGloss\b/gi, "Brillante").replace(/\bMatte Cover\b/gi, "Cubierta mate").replace(/\bMatte\b/gi, "Mate").replace(/\bSilk\b/gi, "Seda").replace(/\bUncoated\b/gi, "Sin recubrimiento").replace(/\bEggshell\b/gi, "Acabado tipo cáscara de huevo").replace(/\bFront only\b/gi, "Solo frente").replace(/\bFront\b/gi, "Frente").replace(/\bBack\b/gi, "Reverso");
    }

    // ---- session + params -------------------------------------------------
    var LS = window.localStorage;
    var sessionId = safeGet("keopsy_ai_session");
    if (!sessionId) { sessionId = "s-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); safeSet("keopsy_ai_session", sessionId); }
    var email = safeGet("keopsy_ai_email") || "";
    var initialPrompt = new URLSearchParams(location.search).get("prompt") || "";
    if (initialPrompt) {
      var promptField = root.querySelector("[data-kp-prompt]");
      if (promptField) promptField.value = initialPrompt;
    }

    // ---- tier / model state ----------------------------------------------
    var tier = "free", credits = null, allowedModels = ["sdxl"], catalogue = [];
    var unlockCode = safeGet("keopsy_ai_code") || "";
    var modelSel = $("[data-kp-model]");

    var q = new URLSearchParams(location.search);
    var linkedOptions = {};
    try {
      var rawOptions = q.get("options");
      if (rawOptions) { var parsedOptions = JSON.parse(rawOptions); if (parsedOptions && typeof parsedOptions === "object" && !Array.isArray(parsedOptions)) linkedOptions = parsedOptions; }
    } catch (_) { linkedOptions = {}; }
    var state = {
      handle: q.get("handle") || "",
      title: q.get("title") || "",
      ret: q.get("ret") || "",
      w: parseFloat(q.get("w")) || 4,
      h: parseFloat(q.get("h")) || 6,
      // 4over small-format standard: 1/16" bleed, 1/8" safety (per certified templates).
      bleed: q.get("bleed") != null ? parseFloat(q.get("bleed")) : 0.0625,
      safe: q.get("safe") != null ? parseFloat(q.get("safe")) : 0.125,
      // shape: rect | rounded | circle | oval  (+ radius in inches for rounded)
      shape: (q.get("shape") || "rect").toLowerCase(),
      radius: parseFloat(q.get("radius")) || 0.125,
      sides: q.get("sides") || "4/4",
      options: linkedOptions,
      fixedSimplex: q.get("fixedSimplex") === "1",
      // locked = opened from a product; the customer cannot change size/shape so the
      // artwork always matches the ordered product (no wrong-size/shape orders).
      lock: q.get("lock") === "1",
    };
    if (!(state.w > 0)) state.w = 4;
    if (!(state.h > 0)) state.h = 6;
    if (!(state.bleed >= 0)) state.bleed = 0.0625;
    if (["rect", "rounded", "circle", "oval"].indexOf(state.shape) === -1) state.shape = "rect";

    if (state.fixedSimplex) state.sides = "4/0";

    // ---- canvas -----------------------------------------------------------
    var canvasEl = $("[data-kp-canvas]");
    var fc = new fabric.Canvas(canvasEl, { backgroundColor: "#ffffff", preserveObjectStacking: true });
    var previewPPI = 96;

    function layout() {
      var aw = state.w + 2 * state.bleed, ah = state.h + 2 * state.bleed;
      var stageMaxW = Math.min(820, (root.querySelector(".kp-studio__stagewrap").clientWidth || 820) - 4);
      var stageMaxH = Math.min(680, Math.round(window.innerHeight * 0.72));
      previewPPI = Math.max(20, Math.min(stageMaxW / aw, stageMaxH / ah));
      var cw = Math.round(aw * previewPPI), ch = Math.round(ah * previewPPI);
      fc.setWidth(cw); fc.setHeight(ch);
      // guides (die-lines) — shaped to the finished product
      var trimI = state.bleed * previewPPI;
      var safeI = (state.bleed + state.safe) * previewPPI;
      var trimEl = $("[data-kp-trim]"), safeEl = $("[data-kp-safe]");
      var tW = cw - 2 * trimI, tH = ch - 2 * trimI, sW = cw - 2 * safeI, sH = ch - 2 * safeI;
      place(trimEl, trimI, trimI, tW, tH);
      place(safeEl, safeI, safeI, sW, sH);
      trimEl.style.borderRadius = cssRadius(state.shape, state.radius * previewPPI, tW, tH);
      safeEl.style.borderRadius = cssRadius(state.shape, (state.radius - state.safe) * previewPPI, sW, sH);
      // Clip the artwork preview to the finished shape so the customer sees the real
      // cut (rounded corners / circle / oval); export stays full-bleed rectangle.
      var clip = clipPathFor(state.shape, trimI, state.radius * previewPPI, tW, tH);
      var wrap = fc.wrapperEl || canvasEl.parentElement, wmEl = $("[data-kp-wm]");
      if (wrap) { wrap.style.clipPath = clip; wrap.style.webkitClipPath = clip; }
      wmEl.style.clipPath = clip; wmEl.style.webkitClipPath = clip;
      // For a plain rectangle there's no clip, so dim the bleed margin instead.
      trimEl.style.boxShadow = state.shape === "rect" ? "0 0 0 9999px rgba(15,23,35,0.32)" : "none";
      var rot = $("[data-kp-rotate]"); if (rot) rot.hidden = state.lock || Math.abs(state.w - state.h) < 0.01;
      var shapeName = root.dataset.locale === "es" ? { rect: "", rounded: "esquinas redondeadas", circle: "círculo", oval: "óvalo" }[state.shape] : { rect: "", rounded: "rounded", circle: "circle", oval: "oval" }[state.shape];
      $("[data-kp-dims]").textContent =
        trim(state.w) + '" × ' + trim(state.h) + '"' + (shapeName ? " · " + shapeName : "") +
        (state.title ? " · " + state.title : "") + "  (+" + trim(state.bleed) + '" ' + (root.dataset.locale === "es" ? "sangrado" : "bleed") + ")";
      if (fc.backgroundImage) coverArtboard(fc.backgroundImage); // keep full-bleed after resize
      fc.renderAll();
    }
    function place(el, l, t, w, h) { el.style.left = l + "px"; el.style.top = t + "px"; el.style.width = Math.max(0, w) + "px"; el.style.height = Math.max(0, h) + "px"; }
    function cssRadius(shape, rpx, w, h) {
      if (shape === "circle" || shape === "oval") return "50%";
      if (shape === "rounded") return Math.max(0, Math.min(rpx, Math.min(w, h) / 2)) + "px";
      return "0";
    }
    function clipPathFor(shape, inset, rpx, w, h) {
      if (shape === "circle" || shape === "oval") return "ellipse(" + (w / 2) + "px " + (h / 2) + "px at 50% 50%)";
      if (shape === "rounded") return "inset(" + inset + "px round " + Math.max(0, Math.min(rpx, Math.min(w, h) / 2)) + "px)";
      return "none";
    }
    layout();
    window.addEventListener("resize", debounce(layout, 200));

    // Guided product/orientation setup. A product already selected in the shop
    // stays linked and sized to its print template; a standalone visit chooses a preset.
    var productSel = $("[data-kp-product]"), linkedProduct = $("[data-kp-linked-product]"), orientSel = $("[data-kp-orientation]"), sidesSel = $("[data-kp-sides]");
    function specSummary() {
      var es = root.dataset.locale === "es";
      var sides = state.sides === "4/0" ? (es ? "una cara" : "one side") : (state.sides === "4/1" ? (es ? "reverso a una tinta" : "one-color back") : (es ? "ambos lados a color" : "full-color both sides"));
      var orientation = state.w >= state.h ? (es ? "horizontal" : "landscape") : (es ? "vertical" : "portrait");
      var shape = state.shape === "circle" ? (es ? "círculo" : "circle") : (state.shape === "oval" ? (es ? "óvalo" : "oval") : (state.shape === "rounded" ? (es ? "esquinas redondeadas" : "rounded corners") : (es ? "rectángulo" : "rectangle")));
      var spec = trim(state.w) + '" × ' + trim(state.h) + '" · ' + shape + " · " + (state.fixedSimplex ? sides : orientation + " · " + sides);
      if (state.lock) spec += " · " + (es ? "sangrado " : "bleed ") + trim(state.bleed) + '" · ' + (es ? "área segura " : "safe area ") + trim(state.safe) + '"';
      $("[data-kp-spec-summary]").textContent = spec;
    }
    function renderLinkedOptions() {
      var wrap = $("[data-kp-linked-options]"); if (!wrap) return;
      var labels = {
        "MATERIAL STOCK": root.dataset.locale === "es" ? "Material / papel" : "Material / stock",
        "STOCK": root.dataset.locale === "es" ? "Material / papel" : "Material / stock",
        "COLORSPEC": root.dataset.locale === "es" ? "Impresión" : "Print color",
        "FINISH COATING": root.dataset.locale === "es" ? "Acabado" : "Finish",
        "FINISH SPOT UV SIZE": root.dataset.locale === "es" ? "Tamaño Spot UV" : "Spot UV size",
        "RUNSIZE": root.dataset.locale === "es" ? "Cantidad" : "Quantity",
        "SHAPE": root.dataset.locale === "es" ? "Forma" : "Shape"
      };
      Object.keys(state.options || {}).forEach(function (key) {
        var normalized = key.trim().toUpperCase();
        if (!labels[normalized] || !state.options[key]) return;
        var row = document.createElement("div"), label = document.createElement("dt"), value = document.createElement("dd");
        row.className = "kp-linked-options__row"; label.textContent = labels[normalized]; value.textContent = root.dataset.locale === "es" ? studioOptionLabel(state.options[key]) : String(state.options[key]);
        row.appendChild(label); row.appendChild(value); wrap.appendChild(row);
      });
      wrap.hidden = wrap.children.length === 0;
    }
    function setProductPreset(option, openCustom) {
      if (!option || option.value === "custom") {
        state.title = state.title || (root.dataset.locale === "es" ? "Diseño personalizado" : "Custom project");
        if (openCustom) $("[data-kp-sizebtn]").click();
        specSummary(); return;
      }
      var w = parseFloat(option.dataset.w), h = parseFloat(option.dataset.h);
      if (w > 0 && h > 0) { state.w = w; state.h = h; state.shape = "rect"; state.title = option.textContent.trim(); orientSel.value = w >= h ? "horizontal" : "vertical"; layout(); }
      specSummary();
    }
    if (state.handle) {
      var source = (state.title + " " + state.handle).toLowerCase();
      var targetProduct = /business.?card|business.?cards|tarjeta/.test(source) ? "business-card" : (/postcard|postal/.test(source) ? "postcard" : (/flyer|volante/.test(source) ? "flyer" : (/rack.?card/.test(source) ? "rack-card" : "custom")));
      productSel.value = targetProduct; productSel.closest(".kp-field").hidden = true; linkedProduct.hidden = false;
      linkedProduct.textContent = (root.dataset.locale === "es" ? "Producto seleccionado: " : "Selected product: ") + (state.title || state.handle);
    } else {
      var brief = initialPrompt.toLowerCase();
      if (/business.?card|lawyer|realtor|dentist|attorney|tarjeta/.test(brief)) productSel.value = "business-card";
      else if (/postcard|postal/.test(brief)) productSel.value = "postcard";
      else if (/flyer|volante|menu|menú/.test(brief)) productSel.value = "flyer";
      else productSel.value = "business-card";
      setProductPreset(productSel.selectedOptions[0], false);
    }
    orientSel.value = state.w >= state.h ? "horizontal" : "vertical";
    sidesSel.value = ["4/0", "4/1", "4/4"].indexOf(state.sides) !== -1 ? state.sides : "4/4";
    if (state.lock || state.fixedSimplex) { $("[data-kp-config-controls]").hidden = true; $("[data-kp-rotate]").hidden = true; }
    specSummary();
    renderLinkedOptions();
    productSel.addEventListener("change", function () { setProductPreset(productSel.selectedOptions[0], productSel.value === "custom"); });
    orientSel.addEventListener("change", function () {
      var portrait = state.h > state.w;
      if ((orientSel.value === "vertical") !== portrait) { var swap = state.w; state.w = state.h; state.h = swap; layout(); }
      specSummary();
    });
    sidesSel.addEventListener("change", function () {
      state.sides = sidesSel.value; specSummary(); updateFaceTabs();
      if (state.sides === "4/0" && currentFace === "back") switchFace("front");
    });

    // Orientation: swap width/height (horizontal ↔ vertical). Allowed even when locked,
    // since it's the same product spec in the other orientation.
    var rotateBtn = $("[data-kp-rotate]");
    if (rotateBtn) rotateBtn.addEventListener("click", function () {
      var t = state.w; state.w = state.h; state.h = t; layout();
      if (orientSel) orientSel.value = state.w >= state.h ? "horizontal" : "vertical";
      if (typeof specSummary === "function") specSummary();
    });

    // ---- Google Fonts catalog --------------------------------------------
    var DEFAULT_FONT = "Poppins";
    var FEATURED_FONTS = [
      "Poppins", "Montserrat", "Roboto", "Oswald", "Playfair Display", "Merriweather",
      "Bebas Neue", "Anton", "Archivo Black", "Pacifico", "Lobster", "Dancing Script",
    ];
    var FONTS = FEATURED_FONTS.slice(), fontSel = $("[data-kp-font]"), fontSearch = $("[data-kp-font-search]"), fontCssLoads = {};
    function renderFontOptions(query, selectedFamily) {
      var term = (query || "").trim().toLowerCase(), matching = FONTS.filter(function (family) { return !term || family.toLowerCase().indexOf(term) !== -1; });
      if (selectedFamily && FONTS.indexOf(selectedFamily) === -1) matching.unshift(selectedFamily);
      fontSel.textContent = "";
      if (!matching.length) {
        var empty = document.createElement("option"); empty.value = ""; empty.textContent = root.dataset.locale === "es" ? "No se encontraron fuentes" : "No fonts found"; fontSel.appendChild(empty); fontSel.disabled = true; return;
      }
      fontSel.disabled = false;
      matching.forEach(function (family) { var option = document.createElement("option"); option.value = family; option.textContent = family; option.style.fontFamily = "'" + family + "', sans-serif"; fontSel.appendChild(option); });
      if (selectedFamily && matching.indexOf(selectedFamily) !== -1) fontSel.value = selectedFamily;
    }
    renderFontOptions("", DEFAULT_FONT);
    fetch(root.getAttribute("data-font-catalog") || "").then(function (response) { if (!response.ok) throw new Error("Font catalog unavailable"); return response.json(); }).then(function (families) {
      if (!Array.isArray(families)) return;
      FONTS = FEATURED_FONTS.concat(families.filter(function (family) { return typeof family === "string" && FEATURED_FONTS.indexOf(family) === -1; }));
      renderFontOptions(fontSearch.value, fontSel.value || DEFAULT_FONT);
      fontSearch.placeholder = (root.dataset.locale === "es" ? "Buscar entre " : "Search ") + FONTS.length.toLocaleString() + " Google Fonts";
    }).catch(function () { /* Keep the featured font list available if the catalog cannot be reached. */ });
    fontSearch.addEventListener("input", function () {
      var active = fc.getActiveObject();
      renderFontOptions(fontSearch.value, (active && active.fontFamily) || fontSel.value || DEFAULT_FONT);
    });
    // Load only the chosen family; avoid downloading thousands of fonts on page entry.
    function withFont(fam, cb) {
      function waitForFace() { if (document.fonts && document.fonts.load) document.fonts.load('24px "' + fam + '"').then(cb, cb); else cb(); }
      if (fontCssLoads[fam]) { fontCssLoads[fam].then(waitForFace, cb); return; }
      var link = document.createElement("link"); link.rel = "stylesheet"; link.href = "https://fonts.googleapis.com/css2?family=" + encodeURIComponent(fam).replace(/%20/g, "+") + "&display=swap";
      fontCssLoads[fam] = new Promise(function (resolve, reject) { link.onload = resolve; link.onerror = reject; });
      document.head.appendChild(link);
      fontCssLoads[fam].then(waitForFace, cb);
    }

    // ---- watermark + text controls visibility -----------------------------
    var syncing = false, backgroundSelected = false;
    function refreshUI() {
      var hasArt = fc.getObjects().length > 0 || !!fc.backgroundImage;
      $("[data-kp-wm]").hidden = !hasArt;
      var a = fc.getActiveObject();
      if (a) backgroundSelected = false;
      var isText = !!(a && a.type === "i-text");
      $("[data-kp-textctrls]").hidden = !isText;
      if (isText) syncTextControls(a);
      var hasObj = !!a && a.type !== "activeSelection";
      var fillable = a && ["rect", "circle", "triangle", "ellipse", "line", "path"].indexOf(a.type) !== -1;
      $("[data-kp-opactrl]").hidden = !hasObj;
      $("[data-kp-fillctrl]").hidden = !fillable;
      $("[data-kp-bg-selected]").hidden = !backgroundSelected;
      $("[data-kp-select-bg]").classList.toggle("is-on", backgroundSelected);
      if (hasObj) {
        syncing = true;
        $("[data-kp-opacity]").value = Math.round((a.opacity == null ? 1 : a.opacity) * 100);
        if (fillable) $("[data-kp-fill]").value = toHex(a.type === "line" ? a.stroke : a.fill);
        syncing = false;
      }
    }
    function syncTextControls(a) {
      syncing = true;
      fontSearch.value = "";
      renderFontOptions("", a.fontFamily || DEFAULT_FONT);
      $("[data-kp-fontsize]").value = Math.round(a.fontSize);
      $("[data-kp-textcolor]").value = toHex(a.fill);
      toggle($("[data-kp-bold]"), a.fontWeight === "bold" || a.fontWeight === 700);
      toggle($("[data-kp-italic]"), a.fontStyle === "italic");
      ["left", "center", "right"].forEach(function (al) {
        toggle(root.querySelector('[data-kp-align="' + al + '"]'), a.textAlign === al);
      });
      syncing = false;
    }
    function toggle(el, on) { if (el) el.classList[on ? "add" : "remove"]("is-on"); }
    function toHex(c) { if (!c || c[0] === "#") return c || "#111111"; var m = String(c).match(/\d+/g); if (!m) return "#111111"; return "#" + m.slice(0, 3).map(function (n) { return ("0" + (+n).toString(16)).slice(-2); }).join(""); }
    fc.on("object:added", refreshUI);
    fc.on("object:removed", refreshUI);
    fc.on("selection:created", refreshUI);
    fc.on("selection:updated", refreshUI);
    fc.on("selection:cleared", refreshUI);
    fc.on("mouse:down", function (event) {
      if (event.target) { backgroundSelected = false; refreshUI(); }
      else if (fc.backgroundImage || fc.backgroundColor) setTimeout(function () { if (!fc.getActiveObject()) { backgroundSelected = true; refreshUI(); } }, 0);
    });

    // ---- generate ---------------------------------------------------------
    var genBtn = $("[data-kp-generate]");
    function setQuota(msg) {
      if (root.dataset.locale === "es" && msg) {
        var es = {"Write a description first.":"Escribe una descripción primero.","The AI engine isn't configured yet (AI API URL).":"El motor de IA aún no está configurado.","Invalid email.":"Correo electrónico no válido.","Thanks! You can keep generating now.":"¡Gracias! Ya puedes seguir creando.","Generate or add something to the canvas first.":"Primero genera o añade un elemento al lienzo.","Preparing…":"Preparando…","Couldn't save the artwork. Check your connection and try again.":"No se pudo guardar el diseño. Revisa tu conexión e inténtalo de nuevo.","Your design was saved. Go back to the product to add it to your cart.":"Tu diseño se guardó. Vuelve al producto para añadirlo al carrito.","Use this design →":"Usar este diseño →","✓ Design saved":"✓ Diseño guardado","You've hit the free limit. Add an order code to keep going with better models.":"Alcanzaste el límite gratuito. Añade un código de pedido para seguir usando modelos avanzados.","That model needs an order or subscription code — enter one above.":"Ese modelo requiere un código de pedido o suscripción. Introdúcelo arriba.","You're out of credits for this code.":"Se agotaron los créditos de este código.","This saved project could not be opened.":"No se pudo abrir el proyecto guardado.","Editable project loaded.":"Proyecto editable cargado."};
        msg = es[msg] || msg;
        if (/generation(s)? left/.test(msg)) msg = msg.replace(/generation(s)? left/, "generaciones restantes").replace(" this session", " en esta sesión");
        if (/^You have \d+ free generations this session\.$/.test(msg)) msg = msg.replace("You have ", "Tienes ").replace(" free generations this session.", " generaciones gratis en esta sesión.");
        if (msg.indexOf("You've hit the free limit.") === 0) msg = "Alcanzaste el límite gratuito. Añade un código de pedido para seguir usando modelos avanzados.";
        if (msg.indexOf("That model needs") === 0) msg = "Ese modelo requiere un código de pedido o suscripción. Introduce uno arriba.";
        if (msg.indexOf("You're out of credits") === 0) msg = "Ya no quedan créditos para este código.";
        if (msg.indexOf("Couldn't generate") === 0) msg = "No se pudo generar el diseño. Inténtalo de nuevo.";
      }
      $("[data-kp-quota]").textContent = msg || "";
    }

    genBtn.addEventListener("click", function () {
      var prompt = ($("[data-kp-prompt]").value || "").trim();
      if (!prompt) { setQuota("Write a description first."); return; }
      if (!API) { setQuota("The AI engine isn't configured yet (AI API URL)."); return; }
      runGenerate(prompt);
    });
    var variations = [], selectedVariation = -1, contentApplied = false, logoObject = null;
    var currentFace = "front", faces = { front: { document: null, variations: [], selected: -1, contentApplied: false }, back: { document: null, variations: [], selected: -1, contentApplied: false } };
    function updateFaceTabs() { var tabs = $("[data-kp-face-tabs]"); tabs.hidden = state.sides === "4/0"; tabs.querySelectorAll("[data-kp-face]").forEach(function (b) { var active = b.dataset.kpFace === currentFace; b.classList.toggle("is-active", active); b.setAttribute("aria-selected", active ? "true" : "false"); }); $("[data-kp-stage]").style.filter = state.sides === "4/1" && currentFace === "back" ? "grayscale(1)" : "none"; }
    function saveCurrentFace() { faces[currentFace] = { document: fc.toJSON(["data"]), variations: variations.slice(), selected: selectedVariation, contentApplied: contentApplied }; }
    function switchFace(nextFace) {
      if (nextFace === currentFace || (nextFace === "back" && state.sides === "4/0")) return Promise.resolve();
      saveCurrentFace(); currentFace = nextFace; var record = faces[currentFace] || { document: null, variations: [], selected: -1, contentApplied: false };
      variations = record.variations || []; selectedVariation = record.selected == null ? -1 : record.selected; contentApplied = !!record.contentApplied; logoObject = null; updateFaceTabs(); renderVariations();
      return new Promise(function (resolve) {
        fc.discardActiveObject(); fc.clear(); fc.setBackgroundColor("#ffffff", function () {
          if (record.document) fc.loadFromJSON(record.document, function () { layout(); fc.renderAll(); refreshUI(); logoObject = fc.getObjects().find(function (o) { return o.data && o.data.keopsyLogo; }) || null; resolve(); });
          else { layout(); fc.renderAll(); refreshUI(); resolve(); }
        });
      });
    }
    root.querySelectorAll("[data-kp-face]").forEach(function (b) { b.addEventListener("click", function () { switchFace(b.dataset.kpFace).then(function () { if (!faces[currentFace].document) setQuota(root.dataset.locale === "es" ? "Añade un fondo y el contenido para el reverso." : "Add a background and content for the back side."); }); }); });
    updateFaceTabs();

    function imageData(blob) {
      return new Promise(function (resolve, reject) { var reader = new FileReader(); reader.onload = function () { resolve(reader.result); }; reader.onerror = reject; reader.readAsDataURL(blob); });
    }
    function requestImage(prompt, assetType, variation, imageWidth, imageHeight) {
      var model = modelSel && modelSel.value ? modelSel.value : "sdxl";
      return fetch(API + "/generate", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ prompt: prompt, assetType: assetType || "background", variation: variation || 1, sessionId: sessionId, email: email, model: model, code: unlockCode, width: imageWidth || state.w, height: imageHeight || state.h }) }).then(function (r) {
        var rem = r.headers.get("X-RateLimit-Remaining"), cred = r.headers.get("X-Credits-Remaining");
        if (cred != null) { credits = parseInt(cred, 10); showTier(); }
        if (rem != null) setQuota(rem + " generation" + (rem === "1" ? "" : "s") + " left" + (email ? "" : " this session") + ".");
        if (r.status === 429) return r.json().then(function (j) { throw { limit: true, needAccount: j.needAccount }; });
        if (r.status === 403) throw { locked: true };
        if (r.status === 402) throw { nocredits: true };
        if (r.status === 503) return r.json().then(function (j) { throw { quotaExceeded: j.error === "model_quota_exhausted", msg: j.error || "service_unavailable" }; });
        if (!r.ok) return r.json().then(function (j) { throw { msg: j.error || "error" }; }).catch(function (e) { if (e && e.msg) throw e; throw { msg: "error" }; });
        return r.blob();
      });
    }
    function showGenerationError(e) {
      if (e && e.limit) { if (e.needAccount && !email) openEmail(); else setQuota("You've hit the free limit. Add an order code to keep going with better models."); }
      else if (e && e.quotaExceeded) {
        setQuota(root.dataset.locale === "es" ? "La generación de imágenes alcanzó el límite diario gratuito. Podrás volver a generar cuando se restablezca. Tu diseño actual se conserva." : "Image generation has reached its free daily limit. You can generate again when it resets. Your current design is saved.");
        openQuotaModal();
      }
      else if (e && e.locked) { $("[data-kp-unlock]").hidden = false; setQuota("That model needs an order or subscription code — enter one above."); }
      else if (e && e.nocredits) setQuota("You're out of credits for this code.");
      else setQuota("Couldn't generate (" + ((e && e.msg) || "error") + "). Please try again.");
    }

    // Daily provider quota is an interrupting service notice, so show it as an
    // accessible dialog and return keyboard focus to the control that opened it.
    var quotaModal = $(`[data-kp-quota-modal]`), quotaClose = $(`[data-kp-quota-close]`), quotaReturnFocus = null;
    function openQuotaModal() {
      var active = document.activeElement;
      quotaReturnFocus = active && !active.closest("[hidden]") ? active : ($(`[data-kp-generate-logo]`) || genBtn);
      quotaModal.hidden = false;
      quotaClose.focus();
    }
    function closeQuotaModal() {
      quotaModal.hidden = true;
      if (quotaReturnFocus && quotaReturnFocus.isConnected && !quotaReturnFocus.disabled) quotaReturnFocus.focus();
    }
    quotaClose.addEventListener("click", closeQuotaModal);
    quotaModal.addEventListener("click", function (event) { if (event.target === quotaModal) closeQuotaModal(); });
    document.addEventListener("keydown", function (event) {
      if (quotaModal.hidden) return;
      if (event.key === "Escape") { event.preventDefault(); closeQuotaModal(); }
      else if (event.key === "Tab") { event.preventDefault(); quotaClose.focus(); }
    });

    // ---- engine / tier picker + unlock codes ------------------------------
    function labelFor(m) {
      var unlocked = m.minTier === "free" || allowedModels.indexOf(m.id) !== -1;
      var lock = (unlocked && m.available) ? "" : "🔒 ";
      var t = m.minTier === "biz" ? (root.dataset.locale === "es" ? " · Negocio" : " · Business") : (m.minTier === "order" ? (root.dataset.locale === "es" ? " · Pedido" : " · Order") : "");
      var label = m.label || "";
      if (root.dataset.locale === "es") label = label.replace(/\bFree\b/g, "Gratis").replace(/\bStandard\b/g, "Estándar");
      return lock + label + t;
    }
    function renderModels() {
      if (!catalogue.length) { modelSel.innerHTML = root.dataset.locale === "es" ? '<option value="sdxl">Estándar (gratis)</option>' : '<option value="sdxl">Standard (free)</option>'; return; }
      var keep = modelSel.value;
      modelSel.innerHTML = "";
      catalogue.forEach(function (m) {
        var unlocked = m.minTier === "free" || allowedModels.indexOf(m.id) !== -1;
        var o = document.createElement("option");
        o.value = m.id; o.textContent = labelFor(m);
        o.disabled = !(unlocked && m.available);
        modelSel.appendChild(o);
      });
      if (keep && !isDisabled(keep)) modelSel.value = keep; else modelSel.value = "sdxl";
    }
    function isDisabled(id) { for (var i = 0; i < modelSel.options.length; i++) if (modelSel.options[i].value === id) return modelSel.options[i].disabled; return true; }
    function setupEngine() {
      if (!API) { renderModels(); return; }
      fetch(API + "/models").then(function (r) { return r.json(); }).then(function (j) {
        catalogue = j.models || []; renderModels();
        if (unlockCode) applyCode(unlockCode, true);
      }).catch(function () { renderModels(); });
    }
    function showTier(err) {
      var b = $("[data-kp-tierbadge]"); b.hidden = false;
      if (err) { b.textContent = err; b.style.background = "#fdeaf0"; b.style.color = "#c31667"; b.style.borderColor = "#f3c6dc"; return; }
      b.style.background = "#e7f8ee"; b.style.color = "#0b7a43"; b.style.borderColor = "#b7e6cd";
      var name = tier === "biz" ? (root.dataset.locale === "es" ? "Negocio" : "Business") : (root.dataset.locale === "es" ? "Pedido" : "Order");
      b.textContent = "✓ " + (root.dataset.locale === "es" ? name + " desbloqueado · " + credits + " créditos" : name + " unlocked · " + credits + " credits");
    }
    function applyCode(code, silent) {
      fetch(API + "/code/check?code=" + encodeURIComponent(code)).then(function (r) { return r.json(); }).then(function (j) {
        if (j.ok) {
          tier = j.tier; credits = j.credits; allowedModels = j.models || ["sdxl"];
          unlockCode = code.trim().toUpperCase(); safeSet("keopsy_ai_code", unlockCode);
          renderModels(); showTier();
          if (!silent && modelSel.options.length > 1) { for (var i = 0; i < modelSel.options.length; i++) if (!modelSel.options[i].disabled && modelSel.options[i].value !== "sdxl") { modelSel.value = modelSel.options[i].value; break; } }
        } else {
          tier = "free"; credits = null; allowedModels = ["sdxl"]; unlockCode = ""; safeSet("keopsy_ai_code", "");
          renderModels(); if (!silent) showTier("Invalid or expired code");
        }
      }).catch(function () { if (!silent) showTier("Couldn't check the code"); });
    }
    $("[data-kp-unlockbtn]").addEventListener("click", function () { var u = $("[data-kp-unlock]"); u.hidden = !u.hidden; });
    $("[data-kp-codeapply]").addEventListener("click", function () { var c = ($("[data-kp-code]").value || "").trim(); if (c) applyCode(c, false); });
    if (unlockCode) $("[data-kp-code]").value = unlockCode;
    setupEngine();

    function runGenerate(prompt) {
      loading(true); genBtn.disabled = true; setQuota("");
      variations.forEach(function (v) { if (v.url) URL.revokeObjectURL(v.url); }); variations = []; selectedVariation = -1;
      faces[currentFace].variations = []; faces[currentFace].selected = -1;
      $("[data-kp-variation-list]").innerHTML = ""; $("[data-kp-variations]").hidden = true;
      // The model receives only a visual-background brief. Editable copy and any
      // customer logo are added later as independent Fabric layers.
      var backgroundBrief = "Print background only for " + prompt + ". Full-bleed decorative background design, no text, no lettering, no numbers, no typography, no logo, no watermark, no product mockup, no photographed business card. Leave generous clean negative space for separately added editable text and an independently supplied logo.";
      (async function () {
        try {
          for (var i = 0; i < 3; i++) {
            setQuota((root.dataset.locale === "es" ? "Creando fondo " : "Generating background ") + (i + 1) + " / 3…");
            var blob = await requestImage(backgroundBrief + " Variation " + (i + 1) + ": use a distinct color palette and composition from other variations.", "background", i + 1);
            variations.push({ data: await imageData(blob), blob: blob }); faces[currentFace].variations = variations.slice();
          }
          renderVariations(); selectVariation(0);
          setQuota(root.dataset.locale === "es" ? "Elige un fondo y edita el texto de ejemplo directamente en el lienzo." : "Choose a background and edit the sample copy directly on the canvas.");
        } catch (e) { renderVariations(); showGenerationError(e); }
        finally { loading(false); genBtn.disabled = false; }
      })();
    }

    function renderVariations() {
      var list = $("[data-kp-variation-list]"); list.innerHTML = "";
      variations.forEach(function (v, i) {
        var b = document.createElement("button"); b.type = "button"; b.className = "kp-variation"; b.setAttribute("aria-pressed", "false");
        var im = document.createElement("img"); im.src = v.data; im.alt = "";
        var label = document.createElement("span"); label.textContent = (root.dataset.locale === "es" ? "Opción " : "Option ") + (i + 1);
        b.appendChild(im); b.appendChild(label); b.addEventListener("click", function () { selectVariation(i); }); list.appendChild(b);
      });
      $("[data-kp-variations]").hidden = variations.length === 0;
    }
    function selectVariation(index) {
      var v = variations[index]; if (!v) return;
      selectedVariation = index;
      faces[currentFace].selected = index;
      $("[data-kp-variation-list]").querySelectorAll(".kp-variation").forEach(function (b, i) { b.classList.toggle("is-active", i === index); b.setAttribute("aria-pressed", i === index ? "true" : "false"); });
      fabric.Image.fromURL(v.data, function (img) {
        coverArtboard(img);
        fc.setBackgroundImage(img, fc.renderAll.bind(fc));
        refreshUI();
        if (!contentApplied) addEditableCopy();
      });
    }
    function coverArtboard(img) {
      var s = Math.max(fc.getWidth() / img.width, fc.getHeight() / img.height);
      img.set({ scaleX: s, scaleY: s, originX: "center", originY: "center", left: fc.getWidth() / 2, top: fc.getHeight() / 2 });
    }

    // ---- edit tools -------------------------------------------------------
    function copyValue(key, fallback) {
      var el = root.querySelector('[data-kp-copy="' + key + '"]');
      return el && el.value.trim() ? el.value.trim() : fallback;
    }
    function addEditableCopy() {
      withFont(DEFAULT_FONT, function () {
      var w = fc.getWidth(), h = fc.getHeight(), dark = "#19313a";
      function text(value, x, y, size, weight, color, align) {
        if (!value) return;
        var obj = new fabric.IText(value, { left: x, top: y, originX: "center", originY: "center", fontFamily: FONTS[0], fontSize: size, fontWeight: weight || "normal", fill: color || dark, textAlign: align || "center", editable: true, data: { keopsyCopy: true } });
        fc.add(obj);
      }
      text(copyValue("business", "Your Business"), w * .5, h * .25, Math.max(12, Math.min(h * .085, w * .075)), "bold", dark);
      text(copyValue("name", "Your Name"), w * .5, h * .44, Math.max(12, Math.min(h * .095, w * .075)), "bold", "#101820");
      text(copyValue("title", "Your Title"), w * .5, h * .55, Math.max(9, Math.min(h * .055, w * .06)), "normal", "#43535a");
      var lines = ["address", "email", "phone", "social", "custom"].map(function (key) { return copyValue(key, ""); }).filter(Boolean);
      if (lines.length) {
        var bodyText = new fabric.IText(lines.join("  ·  "), { left: w * .5, top: h * .76, originX: "center", originY: "center", width: w * .82, fontFamily: FONTS[0], fontSize: Math.max(8, h * .038), fill: "#3f5057", textAlign: "center", lineHeight: 1.25, editable: true, data: { keopsyCopy: true } });
        fc.add(bodyText);
      }
      fc.renderAll(); contentApplied = true; if (faces[currentFace]) faces[currentFace].contentApplied = true;
      var addCopyButton = $("[data-kp-apply-copy]"); if (addCopyButton) { addCopyButton.disabled = true; addCopyButton.textContent = root.dataset.locale === "es" ? "Texto editable añadido ✓" : "Editable copy added ✓"; }
      refreshUI();
      });
    }
    $("[data-kp-apply-copy]").addEventListener("click", addEditableCopy);
    function addLogoLayer(dataUrl, removeWhite) {
      function insert(url) {
        fabric.Image.fromURL(url, function (img) {
          if (logoObject) fc.remove(logoObject);
          var scale = Math.min(fc.getWidth() * .22 / img.width, fc.getHeight() * .3 / img.height);
          img.set({ scaleX: scale, scaleY: scale, originX: "center", originY: "center", left: fc.getWidth() * .5, top: fc.getHeight() * .13, data: { keopsyLogo: true } });
          logoObject = img; fc.add(img); fc.setActiveObject(img); fc.renderAll(); refreshUI();
        });
      }
      if (!removeWhite) return insert(dataUrl);
      var image = new Image(); image.onload = function () {
        var c = document.createElement("canvas"), ctx; c.width = image.naturalWidth; c.height = image.naturalHeight; ctx = c.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(image, 0, 0); var pixels = ctx.getImageData(0, 0, c.width, c.height), d = pixels.data;
        for (var i = 0; i < d.length; i += 4) { var lo = Math.min(d[i], d[i + 1], d[i + 2]), hi = Math.max(d[i], d[i + 1], d[i + 2]); if (lo > 224 && hi - lo < 28) d[i + 3] = Math.round(d[i + 3] * Math.max(0, (250 - lo) / 26)); }
        ctx.putImageData(pixels, 0, 0); insert(c.toDataURL("image/png"));
      }; image.src = dataUrl;
    }
    $("[data-kp-logo-upload]").addEventListener("change", function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      if (f.size > 10 * 1024 * 1024) { setQuota(root.dataset.locale === "es" ? "El logotipo debe pesar menos de 10 MB." : "Please choose a logo smaller than 10 MB."); e.target.value = ""; return; }
      var reader = new FileReader(); reader.onload = function () { addLogoLayer(reader.result, false); };
      reader.readAsDataURL(f); e.target.value = "";
    });
    var logoModal = $(`[data-kp-logomodal]`), logoForm = $(`[data-kp-logoform]`), logoType = $(`[data-kp-logo-type]`), logoName = $(`[data-kp-logo-name]`), logoSubmit = $(`[data-kp-logo-submit]`), logoTrigger = $(`[data-kp-generate-logo]`);
    logoTrigger.addEventListener("click", function () {
      if (!API) { setQuota(root.dataset.locale === "es" ? "El motor de IA no está conectado." : "The AI engine isn't configured yet (AI API URL)."); return; }
      var existingName = copyValue("business", "");
      logoName.value = existingName === "Your Business" ? "" : existingName;
      logoModal.hidden = false; logoType.focus();
    });
    $(`[data-kp-logo-cancel]`).addEventListener("click", function () { logoModal.hidden = true; logoTrigger.focus(); });
    document.addEventListener("keydown", function (event) { if (event.key === "Escape" && !logoModal.hidden) { logoModal.hidden = true; logoTrigger.focus(); } });
    logoForm.addEventListener("submit", function (event) {
      event.preventDefault();
      var businessType = logoType.value.trim(), businessName = logoName.value.trim();
      if (!businessType || !businessName) { logoForm.reportValidity(); return; }
      logoSubmit.disabled = true; logoModal.hidden = true;
      setQuota(root.dataset.locale === "es" ? "Creando un símbolo para " + businessName + "…" : "Creating a logo mark for " + businessName + "…");
      var prompt = "Create a distinctive professional logo symbol for " + businessName + ", a " + businessType + ". Design a clean, memorable standalone brand emblem that clearly suits this business and reproduces well in print at small sizes. Center one simple, polished vector-style icon on a pure white background. Icon only: absolutely no words, letters, initials, numbers, typography, mockups, or extra objects.";
      requestImage(prompt, "logo", 1, 1, 1)
        .then(imageData).then(function (data) { addLogoLayer(data, true); setQuota(root.dataset.locale === "es" ? "Símbolo añadido en una capa independiente y editable." : "Logo symbol added as a separate editable layer."); })
        .catch(showGenerationError).then(function () { logoSubmit.disabled = false; if (quotaModal.hidden) logoTrigger.focus(); });
    });

    $("[data-kp-addtext]").addEventListener("click", function () {
      var t = new fabric.IText("Your text", {
        left: fc.getWidth() / 2, top: fc.getHeight() / 2, originX: "center", originY: "center",
        fontFamily: FONTS[0], fontSize: Math.round(fc.getHeight() / 10), fill: "#111111",
        textAlign: "center", editable: true,
      });
      withFont(FONTS[0], function () { fc.add(t); fc.setActiveObject(t); fc.renderAll(); refreshUI(); });
    });
    $("[data-kp-upload]").addEventListener("change", function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      var rd = new FileReader();
      rd.onload = function () { fabric.Image.fromURL(rd.result, function (img) {
        var s = Math.min(fc.getWidth() / img.width, fc.getHeight() / img.height) * 0.8;
        img.set({ scaleX: s, scaleY: s, originX: "center", originY: "center", left: fc.getWidth() / 2, top: fc.getHeight() / 2 });
        fc.add(img); fc.setActiveObject(img); fc.renderAll(); refreshUI();
      }); };
      rd.readAsDataURL(f); e.target.value = "";
    });
    // Manual design primitives (rectangle / circle / line) for designing without AI.
    function addShape(obj) {
      obj.set({ originX: "center", originY: "center", left: fc.getWidth() / 2, top: fc.getHeight() / 2 });
      fc.add(obj); fc.setActiveObject(obj); fc.renderAll(); refreshUI();
    }
    $("[data-kp-addrect]").addEventListener("click", function () {
      var s = Math.min(fc.getWidth(), fc.getHeight()) * 0.45;
      addShape(new fabric.Rect({ width: s, height: s * 0.66, fill: "#00b3f0" }));
    });
    $("[data-kp-addcircle]").addEventListener("click", function () {
      addShape(new fabric.Circle({ radius: Math.min(fc.getWidth(), fc.getHeight()) * 0.22, fill: "#00b3f0" }));
    });
    $("[data-kp-addline]").addEventListener("click", function () {
      var w = fc.getWidth() * 0.5;
      addShape(new fabric.Line([0, 0, w, 0], { stroke: "#111111", strokeWidth: Math.max(2, fc.getHeight() / 90) }));
    });
    $("[data-kp-back]").addEventListener("click", function () { var a = fc.getActiveObject(); if (a) { fc.sendToBack(a); fc.renderAll(); } });
    $("[data-kp-fill]").addEventListener("input", function (e) {
      var a = fc.getActiveObject(); if (!a || syncing) return;
      if (a.type === "line") a.set("stroke", e.target.value); else a.set("fill", e.target.value);
      fc.requestRenderAll();
    });
    $("[data-kp-opacity]").addEventListener("input", function (e) {
      var a = fc.getActiveObject(); if (!a || syncing) return;
      a.set("opacity", (parseInt(e.target.value, 10) || 100) / 100); fc.requestRenderAll();
    });
    $("[data-kp-dup]").addEventListener("click", function () {
      var a = fc.getActiveObject(); if (!a) return;
      a.clone(function (c) { c.set({ left: a.left + 20, top: a.top + 20 }); fc.add(c); fc.setActiveObject(c); fc.renderAll(); });
    });
    $("[data-kp-front]").addEventListener("click", function () { var a = fc.getActiveObject(); if (a) { fc.bringToFront(a); fc.renderAll(); } });
    function deleteSelectedLayer() {
      var a = fc.getActiveObject();
      if (backgroundSelected) {
        fc.backgroundImage = null;
        fc.setBackgroundColor("rgba(0,0,0,0)", function () { fc.renderAll(); });
        backgroundSelected = false; refreshUI(); return;
      }
      if (!a) return;
      if (a.type === "activeSelection") a.forEachObject(function (o) { fc.remove(o); }); else fc.remove(a);
      if (a === logoObject) logoObject = null;
      fc.discardActiveObject(); fc.renderAll(); refreshUI();
    }
    $("[data-kp-select-bg]").addEventListener("click", function () {
      fc.discardActiveObject(); backgroundSelected = true; refreshUI();
    });
    $("[data-kp-del]").addEventListener("click", deleteSelectedLayer);
    document.addEventListener("keydown", function (e) {
      var active = fc.getActiveObject(), focus = document.activeElement;
      if ((e.key === "Delete" || e.key === "Backspace") && (active || backgroundSelected) && !/INPUT|TEXTAREA|SELECT/.test(focus.tagName) && !focus.isContentEditable && !(active && active.isEditing)) {
        e.preventDefault(); deleteSelectedLayer();
      }
    });
    $("[data-kp-bg]").addEventListener("input", function (e) { backgroundSelected = true; fc.setBackgroundColor(e.target.value, function () { fc.renderAll(); refreshUI(); }); });

    // Text formatting controls (act on the selected i-text).
    function activeText() { var a = fc.getActiveObject(); return (a && a.type === "i-text") ? a : null; }
    fontSel.addEventListener("change", function () {
      var a = activeText(); if (!a || syncing) return;
      var fam = fontSel.value;
      withFont(fam, function () { a.set("fontFamily", fam); fc.requestRenderAll(); });
    });
    $("[data-kp-fontsize]").addEventListener("input", function () {
      var a = activeText(); if (!a || syncing) return;
      var v = parseInt($("[data-kp-fontsize]").value, 10); if (v > 0) { a.set("fontSize", v); fc.requestRenderAll(); }
    });
    $("[data-kp-textcolor]").addEventListener("input", function (e) { var a = activeText(); if (a && !syncing) { a.set("fill", e.target.value); fc.requestRenderAll(); } });
    $("[data-kp-bold]").addEventListener("click", function () {
      var a = activeText(); if (!a) return;
      var on = !(a.fontWeight === "bold" || a.fontWeight === 700); a.set("fontWeight", on ? "bold" : "normal");
      toggle(this, on); fc.requestRenderAll();
    });
    $("[data-kp-italic]").addEventListener("click", function () {
      var a = activeText(); if (!a) return;
      var on = a.fontStyle !== "italic"; a.set("fontStyle", on ? "italic" : "normal");
      toggle(this, on); fc.requestRenderAll();
    });
    ["left", "center", "right"].forEach(function (al) {
      root.querySelector('[data-kp-align="' + al + '"]').addEventListener("click", function () {
        var a = activeText(); if (!a) return;
        a.set("textAlign", al); syncTextControls(a); fc.requestRenderAll();
      });
    });

    // ---- size modal -------------------------------------------------------
    // [name, w, h, shape, radius, bleed]
    var PRESETS = [
      ["Business card", 3.5, 2, "rect", 0, 0.0625],
      ["BC rounded", 3.5, 2, "rounded", 0.125, 0.0625],
      ["Round BC", 2.5, 2.5, "circle", 0, 0.0625],
      ["Oval card", 2, 3.5, "oval", 0, 0.0625],
      ["Postcard 4×6", 4, 6, "rect", 0, 0.0625],
      ["Postcard 5×7", 5, 7, "rect", 0, 0.0625],
      ["Flyer 8.5×11", 8.5, 11, "rect", 0, 0.0625],
      ["Round sticker 3×3", 3, 3, "circle", 0, 0.0625],
      ["Poster 18×24", 18, 24, "rect", 0, 0.125],
    ];
    var presetsWrap = $("[data-kp-presets]");
    PRESETS.forEach(function (p) {
      var b = document.createElement("button"); b.type = "button"; b.className = "kp-preset";
      var shp = { rect: "", rounded: "rounded", circle: "circle", oval: "oval" }[p[3]] || "";
      b.innerHTML = "<b>" + p[0] + "</b><span>" + p[1] + '" × ' + p[2] + '"' + (shp ? " · " + shp : "") + "</span>";
      b.addEventListener("click", function () {
        $("[data-kp-cw]").value = p[1]; $("[data-kp-ch]").value = p[2];
        cshape.value = p[3] || "rect"; $("[data-kp-crad]").value = p[4] || 0; $("[data-kp-cb]").value = p[5] != null ? p[5] : 0.0625;
        toggleRadius();
      });
      presetsWrap.appendChild(b);
    });
    var cshape = $("[data-kp-cshape]");
    function toggleRadius() { $("[data-kp-cradwrap]").style.display = cshape.value === "rounded" ? "" : "none"; }
    cshape.addEventListener("change", toggleRadius);
    $("[data-kp-sizebtn]").addEventListener("click", function () {
      $("[data-kp-cw]").value = state.w; $("[data-kp-ch]").value = state.h; $("[data-kp-cb]").value = state.bleed;
      cshape.value = state.shape; $("[data-kp-crad]").value = state.radius; toggleRadius();
      show("[data-kp-sizemodal]", true);
    });
    $("[data-kp-sizecancel]").addEventListener("click", function () { show("[data-kp-sizemodal]", false); });
    $("[data-kp-sizeok]").addEventListener("click", function () {
      state.w = parseFloat($("[data-kp-cw]").value) || state.w;
      state.h = parseFloat($("[data-kp-ch]").value) || state.h;
      state.bleed = parseFloat($("[data-kp-cb]").value); if (!(state.bleed >= 0)) state.bleed = 0.0625;
      state.shape = cshape.value;
      state.radius = parseFloat($("[data-kp-crad]").value); if (!(state.radius >= 0)) state.radius = 0.125;
      show("[data-kp-sizemodal]", false); layout(); orientSel.value = state.w >= state.h ? "horizontal" : "vertical"; specSummary();
    });
    // A standalone visit now starts with the guided product selector and a useful default size.
    if (state.lock) { var _sb = $("[data-kp-sizebtn]"); if (_sb) _sb.style.display = "none"; } // locked to product template

    // ---- email gate -------------------------------------------------------
    function openEmail() { show("[data-kp-emailmodal]", true); }
    $("[data-kp-emailcancel]").addEventListener("click", function () { show("[data-kp-emailmodal]", false); });
    $("[data-kp-emailok]").addEventListener("click", function () {
      var v = ($("[data-kp-email]").value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { var er = $("[data-kp-emailerr]"); er.hidden = false; er.textContent = root.dataset.locale === "es" ? "Correo electrónico no válido." : "Invalid email."; return; }
      email = v; safeSet("keopsy_ai_email", v); show("[data-kp-emailmodal]", false);
      setQuota("Thanks! You can keep generating now.");
    });

    // Editable project snapshots stay on this device until secure Shopify
    // customer-account storage is connected; final print exports still use R2.
    var projectKey = "keopsy_project_" + (state.handle || "standalone");
    var savedProject = safeGet(projectKey);
    var openProjectButton = $("[data-kp-open-project]");
    openProjectButton.disabled = !savedProject;
    $("[data-kp-save-project]").addEventListener("click", function () {
      saveCurrentFace();
      var faceSnapshots = {}; Object.keys(faces).forEach(function (key) { var f = faces[key]; faceSnapshots[key] = { document: f.document, selected: f.selected, contentApplied: !!f.contentApplied }; });
      var snapshot = { version: 2, title: state.title || "My design", state: { w: state.w, h: state.h, bleed: state.bleed, safe: state.safe, shape: state.shape, radius: state.radius, sides: state.sides }, faces: faceSnapshots, currentFace: currentFace, savedAt: Date.now() };
      try {
        localStorage.setItem(projectKey, JSON.stringify(snapshot)); openProjectButton.disabled = false;
        $("[data-kp-project-status]").textContent = root.dataset.locale === "es" ? "Proyecto editable guardado en este dispositivo. Inicia sesión en la misma cuenta y usa este dispositivo para volver a abrirlo." : "Editable project saved on this device. Reopen it here in the same browser; account sync is not connected yet.";
      } catch (_) { $("[data-kp-project-status]").textContent = root.dataset.locale === "es" ? "No se pudo guardar. Prueba con imágenes más pequeñas." : "Could not save this project here. Try using smaller uploaded images."; }
    });
    openProjectButton.addEventListener("click", function () {
      var raw = safeGet(projectKey); if (!raw) return;
      try {
        var saved = JSON.parse(raw); Object.assign(state, saved.state || {}); state.title = saved.title || state.title;
        if (saved.faces) faces = Object.assign({ front: { document: null, variations: [], selected: -1, contentApplied: false }, back: { document: null, variations: [], selected: -1, contentApplied: false } }, saved.faces);
        else if (saved.canvas) faces = { front: { document: saved.canvas, variations: [], selected: -1, contentApplied: false }, back: { document: null, variations: [], selected: -1, contentApplied: false } };
        currentFace = saved.currentFace || "front"; var current = faces[currentFace]; sidesSel.value = state.sides || "4/4"; updateFaceTabs();
        if (!current || !current.document) throw new Error("empty project");
        layout(); fc.loadFromJSON(current.document, function () { layout(); fc.renderAll(); refreshUI(); contentApplied = !!current.contentApplied || fc.getObjects().some(function (o) { return o.data && o.data.keopsyCopy; }); logoObject = fc.getObjects().find(function (o) { return o.data && o.data.keopsyLogo; }) || null; variations = current.variations || []; selectedVariation = current.selected == null ? -1 : current.selected; renderVariations(); specSummary(); $("[data-kp-project-status]").textContent = root.dataset.locale === "es" ? "Proyecto editable cargado." : "Editable project loaded."; });
      } catch (_) { $("[data-kp-project-status]").textContent = root.dataset.locale === "es" ? "No se pudo abrir el proyecto guardado." : "This saved project could not be opened."; }
    });

    // ---- use this design → export + save + hand back ----------------------
    var useBtn = $("[data-kp-use]");
    useBtn.addEventListener("click", function () {
      if (fc.getObjects().length === 0 && !fc.backgroundImage) { setQuota("Generate or add something to the canvas first."); return; }
      saveCurrentFace();
      var requiredFaces = state.sides === "4/0" ? ["front"] : ["front", "back"];
      var missingFace = requiredFaces.find(function (name) { return !faceHasArtwork(faces[name]); });
      if (missingFace) {
        switchFace(missingFace).then(function () { useBtn.disabled = false; useBtn.textContent = root.dataset.locale === "es" ? "Usar este diseño →" : "Use this design →"; setQuota(root.dataset.locale === "es" ? (missingFace === "back" ? "Diseña y genera el reverso antes de guardar un trabajo a dos caras." : "Diseña y genera el frente antes de guardar este proyecto.") : (missingFace === "back" ? "Create and generate the back side before saving a two-sided design." : "Create and generate the front side before saving this project.")); });
        return;
      }
      fc.discardActiveObject(); fc.renderAll();
      useBtn.disabled = true; useBtn.textContent = root.dataset.locale === "es" ? "Preparando…" : "Preparing…";
      // Wait for all web fonts to finish loading so text exports in the chosen font.
      var ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
      ready.then(function () { fc.renderAll(); exportAndSave(); });
    });

    function exportAndSave() {
      saveCurrentFace(); var returnFace = currentFace;
      var sidesToSave = state.sides === "4/0" ? ["front"] : ["front", "back"];
      (async function () {
        var saved = {}, frontThumb = "";
        try {
          for (var i = 0; i < sidesToSave.length; i++) {
            var faceName = sidesToSave[i]; await switchFace(faceName);
            fc.discardActiveObject(); fc.renderAll();
            var dataURL = fc.toDataURL({ format: "png", multiplier: 300 / previewPPI });
            if (faceName === "back" && state.sides === "4/1") dataURL = await grayscalePNG(dataURL);
            if (faceName === "front") frontThumb = fc.toDataURL({ format: "png", multiplier: Math.min(0.35, 220 / fc.getWidth()) });
            if (!API) { saved[faceName] = dataURL; continue; }
            var blob = await dataUrlToBlob(dataURL);
            var response = await fetch(API + "/save?sessionId=" + encodeURIComponent(sessionId) + "&handle=" + encodeURIComponent((state.handle || "art") + "-" + faceName), { method: "POST", headers: { "Content-Type": "image/png" }, body: blob });
            var result = await response.json(); if (!response.ok || !result.url) throw new Error("save failed"); saved[faceName] = result.url;
          }
          await switchFace(returnFace); storeArtwork(saved.front, saved.back || "", frontThumb);
          // Artwork created from a paid order is attached to that order before
          // returning to its dashboard and advancing the production queue.
          if (q.get('orderToken') && q.get('orderItem')) {
            var submit = await fetch(API + '/order-artwork/' + encodeURIComponent(q.get('orderToken')) + '/submit-design?item=' + encodeURIComponent(q.get('orderItem')), {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url: saved.front, backUrl: saved.back || '' })
            });
            if (!submit.ok) throw new Error('order artwork submit failed');
          }
          handBack();
        } catch (_) {
          useBtn.disabled = false; useBtn.textContent = root.dataset.locale === "es" ? "Usar este diseño →" : "Use this design →";
          setQuota(root.dataset.locale === "es" ? "No se pudo guardar el diseño. Revisa tu conexión e inténtalo de nuevo." : "Couldn't save the artwork. Check your connection and try again.");
        }
      })();
    }

    function faceHasArtwork(faceRecord) {
      var doc = faceRecord && faceRecord.document;
      return !!(doc && ((doc.objects && doc.objects.length) || (doc.backgroundImage && doc.backgroundImage.src)));
    }
    function grayscalePNG(dataURL) {
      return new Promise(function (resolve) {
        var image = new Image(); image.onload = function () {
          var c = document.createElement("canvas"), ctx; c.width = image.naturalWidth; c.height = image.naturalHeight; ctx = c.getContext("2d", { willReadFrequently: true }); ctx.drawImage(image, 0, 0);
          var pixels = ctx.getImageData(0, 0, c.width, c.height), d = pixels.data;
          for (var i = 0; i < d.length; i += 4) { var y = Math.round(d[i] * .2126 + d[i + 1] * .7152 + d[i + 2] * .0722); d[i] = y; d[i + 1] = y; d[i + 2] = y; }
          ctx.putImageData(pixels, 0, 0); resolve(c.toDataURL("image/png"));
        }; image.onerror = function () { resolve(dataURL); }; image.src = dataURL;
      });
    }
    function storeArtwork(url, backUrl, thumb) {
      var rec = { url: url, frontUrl: url, backUrl: backUrl || "", thumb: thumb, w: state.w, h: state.h,
        shape: state.shape, bleed: state.bleed, safe: state.safe, sides: state.sides, options: state.options || {}, ts: Date.now() };
      safeSet("keopsy_artwork_" + (state.handle || "art"), JSON.stringify(rec));
    }
    function handBack() {
      if (state.ret) { location.href = addParam(state.ret, "kp_art", "1"); }
      else { useBtn.textContent = root.dataset.locale === "es" ? "✓ Diseño guardado" : "✓ Design saved"; setQuota("Your design was saved. Go back to the product to add it to your cart."); }
    }
    // ---- helpers ----------------------------------------------------------
    function loading(on) { $("[data-kp-loading]").hidden = !on; }
    function show(sel, on) { $(sel).hidden = !on; }
    function trim(n) { return String(Math.round(n * 100) / 100); }
    function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
    function safeGet(k) { try { return LS.getItem(k); } catch (e) { return null; } }
    function safeSet(k, v) { try { LS.setItem(k, v); } catch (e) {} }
    function addParam(u, k, v) { return u + (u.indexOf("?") === -1 ? "?" : "&") + k + "=" + v; }
    function dataUrlToBlob(d) { return fetch(d).then(function (r) { return r.blob(); }); }

    setQuota(email ? "" : "You have " + FREE + " free generations this session.");
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
